module.exports = __webpack_public_path__ + "static/media/14.3bf1b853.jpg";